import { render, staticRenderFns } from "./AIAutoPanel.vue?vue&type=template&id=3440a37c&scoped=true"
import script from "./AIAutoPanel.vue?vue&type=script&lang=js"
export * from "./AIAutoPanel.vue?vue&type=script&lang=js"
import style0 from "./AIAutoPanel.vue?vue&type=style&index=0&id=3440a37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440a37c",
  null
  
)

export default component.exports